import { render, staticRenderFns } from "./MceGradientComponent.vue?vue&type=template&id=35cb6520&"
import script from "./MceGradientComponent.vue?vue&type=script&lang=js&"
export * from "./MceGradientComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports